// src/app/routes/AppRoutes.tsx

import { lazy } from "react"
import {
  Navigate,
  Route,
  Routes,
} from "react-router-dom"

//import RouteInstanceEngine from "@/app/routes/RouteInstanceEngine"

import NotFound from "@/app/pages/notFound"
import Notificacion from "@/app/pages/buzon"
//import Notificacion from "@/app/pages/notificaciones"
import OfflineManager from "@/app/pages/offlinePage"
import FavoritoseManager from "@/app/pages/favoritosPage"
import AlbumPage from "@/app/pages/albumPage/AlbumPage"
import PodcastPage from "@/app/pages/podcastPage/PodcastPage"
import Performance from "@/features/performance/PerformancePage"
import IframeLanding from "@/features/iframes/iframeLanding/iframeLanding"
import IframeScroll from "@/features/iframes/iframeScroll/iframeScroll"
import IframePromote from "@/features/iframes/iframePromote/iframePromote"
import IframeAtropos from "@/features/iframes/iframeAtropos/iframeAtropos"
import IframeOnboard from "@/features/iframes/iframeOnboard/iframeOnboard"
import IframeEditorializado from "@/components/banner/editorializado/IframeEditorializado"
import Subir from "@/app/pages/subirTrack/subir"
import MetadataExtractor from "@/app/pages/dashPage/dashPlaylists"



// ------------------
// Lazy Routes
// ------------------
const Home = lazy(() => import("@/app/pages/homePage/home"))
const DashRadio = lazy(() => import("@/app/pages/dashPage/dashRadio"))
const Rutas = lazy(() => import("@/features/rutas"))

const EditStory = lazy(() => import("@/app/pages/storyStudio/RadioStoryPage"))
const MixtapeCard = lazy(() => import("@/features/idCards/idMixtape/idMixtape.page"))
const TrackPage = lazy(() => import("@/app/pages/trackPage/TrackPage"))
const Id4b = lazy(() => import("@/features/idCards/id4b/id4b.page"))
const Library = lazy(() => import("@/app/pages/libraryPage"))
const Terms = lazy(() => import("@/app/pages/terms/terms"))
const Policy = lazy(() => import("@/app/pages/terms/ContentPolicy"))
const Filtro = lazy(() => import("@/app/pages/filtroPage"))
const Radio = lazy(() => import("@/app/pages/radioPage"))
const DashTags = lazy(() => import("@/app/pages/radioTags"))
const Descubre = lazy(() => import("@/features/shorts/App"))
const PlaylistPage = lazy(() => import("@/app/pages/playlistPage/playlist"))
const Djs = lazy(() => import("@/app/pages/djsPage"))
const ArtistPage = lazy(() => import("@/app/pages/artistPage/ArtistPage"))
const FlappyBird = lazy(() => import("@/app/pages/ajustesPage/components/game/flappy"))
const Tarjetas = lazy(() => import("@/app/pages/tarjetas/tarjetas"))
const Ajustes = lazy(() => import("@/app/pages/ajustesPage"))
const Insights = lazy(() => import("@/app/pages/insights"))
const Buscar = lazy(() => import("@/app/pages/buscarPage"))
const Dash = lazy(() => import("@/app/pages/dashPage/dash"))
const DashboardPlaylist = lazy(() => import("@/features/dashboard/dashboardPlaylist"))
const ConvertirLista = lazy(() => import("@/app/pages/dashPage/dashImport"))
const Sello = lazy(() => import("@/app/pages/sello"))
const Inscripcion = lazy(() => import("@/app/pages/dashPage/inscripcion/inscripcion"))
const Proposito = lazy(() => import("@/features/proposito"))
const DashboardApp = lazy(() => import("@/features/dashboard/dashboardApp/DashboardApp"))
const Eventos = lazy(() => import("@/app/pages/dashPage/eventos/eventos"))
const Perfil = lazy(() => import("@/app/pages/ajustesPage/components/userProfile/user-profile"))
const CustomProfile = lazy(() => import("@/app/pages/ajustesPage/components/customProfile/CustomProfile"))
const Mixes = lazy(() => import("@/app/pages/misMixes"))
const MixtapeStudio = lazy(() => import("@/app/pages/studioPage"))
const DemosUsuarios = lazy(() => import("@/app/pages/demosPage"))
//const RealityVFX = lazy(() => import("@/app/pages/blog/RealityVFX"))

const Notis = lazy(() => import("@/app/pages/notis/notis"))

const Precio = lazy(() => import("@/app/pages/precioPage"))


const Registro1 = lazy(() => import("@/app/pages/auth/sign-up/page"))
const Registro2 = lazy(() => import("@/app/pages/auth/sign-up-2/page"))
const Registro3 = lazy(() => import("@/app/pages/auth/sign-up-3/page"))
const InicioSesion1 = lazy(() => import("@/app/pages/auth/sign-in/page"))
const InicioSesion2 = lazy(() => import("@/app/pages/auth/sign-in-2/page"))
const InicioSesion3 = lazy(() => import("@/app/pages/auth/sign-in-3/page"))




// ---------------------
// Types
// ---------------------
type AppRoutesProps = {
  user: unknown
  centerRef: React.RefObject<HTMLDivElement | null>
}

// -----------------------------------------------
// Routes (WRAPPED IN KEEP ALIVE ENGINE)
// -----------------------------------------------

//export default function AppRoutes({ user }: AppRoutesProps) {
export default function AppRoutes({ user, centerRef }: AppRoutesProps) {
  return (
    

      <Routes>

        {/* AUTH */}
        {/* <Route path="/login" element={user ? <Navigate to="/" /> : <Registro1 />} /> */}

        <Route path="/registro" element={user ? <Navigate to="/" /> : <Registro1 />} />
        <Route path="/registro/paso-2" element={<Registro2 />} />
        <Route path="/registro/paso-3" element={<Registro3 />} />

        <Route path="/inicio" element={<InicioSesion1 />} />
        <Route path="/inicio-2" element={<InicioSesion2 />} />
        <Route path="/inicio-3" element={<InicioSesion3 />} />


        {/* <Route path="/login" element={user ? <Navigate to="/" /> : <Auth />} /> */}

        {/* MAIN */}
        <Route path="/" element={<Home />} />

        {/* GENERAL */}
        <Route path="/dashedit" element={<EditStory />} />
        <Route path="/ruta" element={<Rutas />} />
        <Route path="/mixtape" element={<MixtapeCard />} />
        <Route path="/track/:playlistId/:trackId" element={<TrackPage />} />
        <Route path="/go" element={<Id4b />} />
        <Route path="/sello" element={<Sello />} />
        <Route path="/library/*" element={<Library />} />
        <Route path="/news" element={<Tarjetas />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/performance" element={<Performance />} />
        <Route path="/filtro" element={<Filtro />} />
        <Route path="/buscar" element={<Buscar />} />
        <Route path="/djs" element={<Djs />} />
        <Route path="/radio" element={<Radio />} />
        <Route path="/dashtags" element={<DashTags />} />
        <Route path="/descubre" element={<Descubre />} />
        <Route path="/notificaciones" element={<Notificacion />} />
        {/* <Route path="/buzon" element={<Buzon />}/> */}
        <Route path="/flappy" element={<FlappyBird />} />
        <Route path="/offline" element={<OfflineManager />} />
        <Route path="/favoritos" element={<FavoritoseManager />} />
        <Route path="/ajustes" element={<Ajustes />} />
        <Route path="/insights" element={<Insights />} />

        <Route path="/dashradio" element={<DashRadio />} />

        <Route path="/mixes" element={<Mixes />} />
        <Route path="/mixtape-studio" element={<MixtapeStudio />} />
        <Route path="/demos" element={<DemosUsuarios />} />

        {/* USER */}
        <Route path="/u" element={<Perfil />} />
        <Route path="/u/custom" element={<CustomProfile />} />

        {/* MEDIA */}
        <Route path="/album/:link" element={<AlbumPage />} />
        <Route path="/podcast/:link" element={<PodcastPage />} />
        <Route path="/playlist/:path" element={<PlaylistPage />} />
        <Route path="/artist/:path" element={<ArtistPage />} />

        {/* DASH */}
        <Route path="/dash" element={<Dash />} />
        <Route path="/dashcurate" element={<DashboardPlaylist />} />
        <Route path="/dashplaylist" element={<MetadataExtractor />} />
        <Route path="/dashapp" element={<DashboardApp />} />
        {/* <Route path="/espacios" element={<DashboardEspacios />} /> */}
        <Route path="/dasheventos" element={<Eventos />} />
        <Route path="/inscripcion" element={<Inscripcion />} />
        <Route path="/convertir" element={<ConvertirLista />} />

        {/* UPLOAD */}
        <Route path="/subir" element={<Subir />} />
        <Route path="/proposito" element={<Proposito />} />
        {/* <Route path="/blog" element={<RealityVFX />} /> */}
        <Route path="/notis" element={<Notis />} />


        <Route path="/precio" element={<Precio />} />

        {/* IFRAME */}
        <Route path="/start" element={<IframeLanding />} />
        <Route path="/scroll" element={<IframeScroll />} />
        <Route path="/editorializado" element={<IframeEditorializado />} />
        <Route path="/publicar" element={<IframePromote />} />
        <Route path="/atropos" element={<IframeAtropos />} />
        <Route path="/onboard" element={<IframeOnboard />} />

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
        

      </Routes>
  )
}